import { KeepAlive } from 'react-activation';
import { SListTabs } from 'shj-components'
import GeneralManage from "@/pages/baseProduct/generalManage";
import { StandardManage } from "@/pages/baseProduct/generalStandardManage/list/standard";
import { useSearchParams } from "react-router-dom";
import { useSetState } from "ahooks";
import { useEffect } from "react";

const GeneralStandardManage = () => {
  const [search] =  useSearchParams()
  const tabKey = search.get('tabKey')
  const businessId = search.get('businessId') || undefined

  const [state, setState] = useSetState({
    activeKey: '',
  })

  useEffect(() => {
    setState({activeKey: tabKey || 'GENERAL'})
  }, [tabKey, setState]);

  const items = [
    {
      label: '通项配置',
      key: 'GENERAL',
      children: <GeneralManage />,
    },
    {
      label: '标配管理',
      key: 'STANDARD',
      children: <StandardManage businessId={businessId} />,
    }
  ]

  return <KeepAlive name={location.pathname}>
    <SListTabs  activeKey={state.activeKey}
                onChange={(key: string) => setState({ activeKey: key })}
                items={items} auth={false}/>
  </KeepAlive>
}

export default GeneralStandardManage
